// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".imagesBox {\n  width: 100%;\n  overflow: hidden;\n}\n.imagesBox img {\n  width: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/components/ImageViewer/index.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;AACb","sourcesContent":[".imagesBox {\n  width: 100%;\n  overflow: hidden;\n}\n.imagesBox img {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
